import React from 'react'
import './footer.css'
import { FaFacebookF } from 'react-icons/fa'
import { BsLinkedin } from 'react-icons/bs'
import { BsGithub } from 'react-icons/bs'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo' >Hau Nguyen</a>
      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
      <div className="footer__socials">
        <a href="https://www.facebook.com/dinhhau.nguyen.7"><FaFacebookF /></a>
        <a href="https://www.linkedin.com/in/haunguyen04/" target="_blank"><BsLinkedin /></a>
        <a href="https://github.com/DinhHauNguyen" target="_blank"><BsGithub /></a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Hau Nguyen. All right reserved.</small>
      </div>
    </footer>
  )
}

export default Footer